// src/me/LinkToUmat.js
import React, { useState } from "react";
import FormLayout from "../layouts/FormLayout";
import { apiFetch } from "../utils/wkCommon";
import { useHistory } from "react-router-dom";
import { getUser } from "../utils/auth";

export function LinkToUmat() {
  const [kode, setKode] = useState("");
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const authUser = getUser();
  const currentEmail = authUser?.email || "";

  async function onSubmit(e) {
    e.preventDefault();
    setMsg("");
    const kodeTrim = (kode || "").trim();
    if (!kodeTrim) {
      setMsg("Masukkan kode umat yang valid.");
      return;
    }

    if (!currentEmail) {
      setMsg("Email user tidak ditemukan. Silakan login terlebih dahulu.");
      return;
    }

    setLoading(true);
    try {
      const listResp = await apiFetch(`/api/umats?filters%5BkodeUmat%5D%5B$eq%5D=${encodeURIComponent(kodeTrim)}&populate=*`);

      const arr = Array.isArray(listResp?.data)
        ? listResp.data
        : (listResp?.data ? (Array.isArray(listResp.data) ? listResp.data : [listResp.data]) : []);

      if (!arr || arr.length === 0) {
        setMsg(`Kode "${kodeTrim}" tidak ditemukan. Periksa kembali kode umat.`);
        setLoading(false);
        return;
      }

      const first = arr[0];
      const id = first.id || (first?.attributes && first.attributes.id);
      if (!id) {
        setMsg("Data umat ditemukan tapi ID tidak tersedia — silakan hubungi admin.");
        setLoading(false);
        return;
      }

      const updateBody = { data: { LoginEmail: currentEmail } };
      const updated = await apiFetch(`/api/umats/${id}`, { method: "PUT", body: updateBody });

      const payload = updated?.data ? updated.data : updated;
      const umatObj = payload?.attributes ? { id: payload.id, ...payload.attributes } : payload;
      try {
        localStorage.setItem("umatData", JSON.stringify(umatObj));
        if (umatObj.umatID) localStorage.setItem("umatID", umatObj.umatID);
        if (umatObj.kodeUmat) localStorage.setItem("kodeUmat", umatObj.kodeUmat);
      } catch (e) {
        console.warn("Could not persist umat data", e);
      }

      setMsg("Berhasil mengaitkan akun ke umat.");
      setTimeout(() => history.push("/me"), 700);
    } catch (err) {
      console.error(err);
      setMsg("Gagal menghubungkan ke umat. " + (err?.message || String(err)));
    } finally {
      setLoading(false);
    }
  }

  const leftPanelNode = (
    <div>
      <div style={{ fontWeight: 700, marginBottom: 8 }}>Syarat & Ketentuan</div>
      <ul style={{ paddingLeft: 16 }}>
        <li>Masukkan kode umat yang diberikan pendahulu/admin untuk mengaitkan akun Anda.</li>
        <li>Pastikan Anda mengisi dengan data milik sendiri dan data sebenarnya.</li>
        <li>Kesalahan input/verifikasi dapat menyebabkan akun Anda terblokir.</li>
      </ul>
    </div>
  );

  const infoNode = msg ? <div style={{ color: msg.startsWith("Gagal") ? "crimson" : "green" }}>{msg}</div> : null;

  return (
    <FormLayout
      title="Verifikasi Data"
      onSubmit={onSubmit}
      submitLabel={loading ? "Menghubungkan..." : "Hubungkan"}
      hideTopButton={true}
      leftPanelNode={leftPanelNode}
      rightPanelNode={(
        <div>
          <div style={{ fontWeight: 700, marginBottom: 8 }}>Petunjuk Pengisian</div>
          <ul style={{ paddingLeft: 16 }}>
            <li>Masukkan kode persis seperti yang diterima.</li>
            <li>Setelah berhasil, Anda akan diarahkan ke halaman profil.</li>
            <li>Jika terdapat masalah, hubungi admin untuk verifikasi data.</li>
          </ul>
        </div>
      )}
      infoNode={infoNode}
    >
      <div style={{ maxWidth: 640 }}>
        <div style={{ marginBottom: 12 }}>
          <label style={{ display: "block", marginBottom: 6, color: "#2b4a84", fontWeight: 600 }}>Kode Umat</label>
          <input
            placeholder="Kode Umat"
            value={kode}
            onChange={(e) => setKode(e.target.value)}
            style={{ width: "100%", padding: 10, border: "2px solid #2b4a84", borderRadius: 6 }}
          />
        </div>
        <div style={{ marginTop: 8 }}>
          <div style={{ fontSize: 13, color: "#666" }}>Email akun yang akan ditautkan: <strong>{currentEmail || "-"}</strong></div>
        </div>
      </div>
    </FormLayout>
  );
}
